'use strict';

import Vue from 'vue';
import axios from 'axios';
import EventBus from '@/helpers/event-bus';
import Util from '@/mixins/util';
import i18n from '@/i18n';

let config = {
  baseURL: process.env.VUE_APP_AXIOSBASE,
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  function(config) {
    if (!config.url.includes('/api/v1/auth')) {
      let token = localStorage.token;
      if (token) config.headers.Authorization = 'Bearer ' + token;

      config.headers['Accept-Language'] = localStorage.getItem('locale')
        ? localStorage.getItem('locale')
        : 'en';
    }
    return config;
  },
  function(error) {
    return Promise.reject(error);
  },
);

_axios.interceptors.response.use(
  function(response) {
    if (!response.config.url.includes('/api/v1/auth') && response.config.url.includes('/api/v1')) {
      if (localStorage.tokenIsRefreshing === 'false') {
        localStorage.tokenIsRefreshing = true;
        _axios
          .post('/api/v1/auth/refresh', localStorage.refresh_token, {
            headers: { 'Content-Type': 'application/json' },
          })
          .then(res => {
            Util.methods.setLocalStorage(res.data);
          })
          .catch(error => {
            console.log(error);
          })
          .finally(() => {
            localStorage.tokenIsRefreshing = false;
          });
      }
    }
    return response;
  },
  function(error) {
    console.log(error.response.config.url);
    if (error.response.status === 500) {
      EventBus.$emit('snackbar', {
        text: i18n.t('errorlist.error-500'),
        color: 'error',
      });
    } else if (error.response.status === 404) {
      EventBus.$emit('snackbar', {
        text: i18n.t('errorlist.error-404'),
        color: 'warning',
      });
    } else if (error.response.status === 403) {
      window.location.href = '/page-403';
    } else if (error.response.status === 401) {
      if (error.response.config.url.includes('/api/v1/auth')) {
        window.location.href = process.env.VUE_APP_LOGINPATH;
      } else {
        window.location.href = '/page-401';
      }
    } else if (error.response.status === 400) {
      EventBus.$emit('snackbar', {
        text: i18n.t('errorlist.error-400'),
        color: 'warning',
      });
    }
    return Promise.reject(error);
  },
);

Plugin.install = function(Vue) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      },
    },
    $axios: {
      get() {
        return _axios;
      },
    },
  });
};

Vue.use(Plugin);

export default Plugin;

export { _axios };
